import * as React from "react";
import Typography from "@mui/material/Typography";

interface TitleProps {
  children?: React.ReactNode;
  color?: string;
}

export default function SubTitle({
  children,
  color = "text.primary",
}: TitleProps) {
  return (
    <Typography
      component="h2"
      variant="subtitle2"
      color={color}
      gutterBottom
    >
      {children}
    </Typography>
  );
}
